import Iconify from "@/src/components/iconify/Iconify";
import IconCode from "@/src/lib/iconCode";

import Image from "next/image";
import NextLink from "next/link";
import { NEXT_IMAGE_CDN } from "@/src/lib/util/config";
import Link from "next/link";

const CommonlyBookedTest = ({ row }) => {
    // const cardImage = row?.configProductCard?.categoryCardImage || "";
    const urlSlug = row?.configProductCard?.urlSlug || "";

    return (
        <div className="md:py-4">
            <div className="bg-white p-2 rounded-lg shadow-md md:mx-3 outline-0 outline-dashed outline-primary hover:outline-1">
                {/* <div className="relative min-h-44">
                    <Image
                        src={`${NEXT_IMAGE_CDN}/${cardImage}`}
                        alt={row?.productName}
                        layout="fill"
                        objectFit="cover"
                        className="rounded-lg"
                    />
                </div> */}

                <p className="md:text-base text-sm font-bold md:mt-3 mt-2 mb-1 text-black">
                    {row?.productName}
                </p>
                <div
                    className="text-gray-600 md:text-sm line-clamp-3 px-1"
                    dangerouslySetInnerHTML={{ __html: row?.bodyHtml }}
                ></div>

                <div className="flex flex-row gap-2 md:my-4 my-3">
                    {row?.maxPrice == row?.minPrice ? (
                        <p className="text-gray-800 md:text-lg text-base font-bold flex items-center">
                            <Iconify icon={IconCode.rupeeBold} width="16px" />{" "}
                            {row?.minPrice}
                        </p>
                    ) : (
                        <>
                            <p className="text-gray-800 md:text-lg text-base font-bold flex items-center">
                                <Iconify
                                    icon={IconCode.rupeeBold}
                                    width="16px"
                                />{" "}
                                {row?.minPrice}
                            </p>
                            <p className="text-black">-</p>
                            <p className="text-gray-800 md:text-lg text-base font-bold flex items-center">
                                <Iconify
                                    icon={IconCode.rupeeBold}
                                    width="16px"
                                />{" "}
                                {row?.maxPrice}
                            </p>
                        </>
                    )}
                </div>

                <div className="mt-2 flex">
                    <Link
                        href={`/test/${urlSlug}`}
                        className="bg-white border border-solid border-primary text-center text-primary px-4 py-2 rounded-md font-medium text-sm hover:bg-primary hover:text-white transition-all duration-300 w-full uppercase   "
                    >
                        Book Now
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default CommonlyBookedTest;
